<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.base_setting')" class="nav-bar info-nav">
      <template #left>
        <van-icon name="arrow-left" class="nav-back" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="page-body">
      <div class="items">
        <div @click="openHerderImg()" class="item">
          <div class="left">{{$t("setting.avatar")}}</div>
          <div class="right">
            <img src="/img/home/avatar.png" class="avatar-preview">
          </div>
        </div>
        <!-- <van-popup v-model="show" position="bottom" round :style="{ height: '50%' }">
            <div class="avatarbox">
                <div class="title van-hairline--bottom">
                  <van-icon @click="show=false" name="cross" />
                  <div class="text">{{$t("setting.choose_avatar")}}</div>
                  <div class="btnok" @click="check()">{{$t("setting.ok")}}</div>
                </div>
                <div class="content">
                  <van-image
                      round
                      v-for="(item,index) in 185" :key="index"
                      @click="select_header_img('https://zxbuk.oss-cn-hongkong.aliyuncs.com/images/avatar/avatar'+item+'.png')"
                      :class="{ 'choose': isActive ===  'https://zxbuk.oss-cn-hongkong.aliyuncs.com/images/avatar/avatar'+item+'.png'}"
                      :src="'https://zxbuk.oss-cn-hongkong.aliyuncs.com/images/avatar/avatar'+item+'.png'"
                  />
                </div>
            </div>
        </van-popup> -->
        <div class="item">
          <div class="left">{{$t('foorter.top25')}}</div>
          <div class="right">
            <span class="desc">{{this.userInfo.username ? this.userInfo.username : this.$t("setting.no_setting")}}</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="item" @click="toSetName()">
          <div class="left">{{$t("setting.real_name")}}</div>
          <div class="right">
            <span class="desc">{{this.userInfo.name ? this.userInfo.name : this.$t("setting.no_setting")}}</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="item" @click="toSetSex()">
          <div class="left">{{$t("setting.sex")}}</div>
          <div class="right">
            <span class="desc">{{this.userInfo.sex !== "0" ? this.userInfo.sex === "1" ? this.$t("setting.man") :this.$t("setting.female"): this.$t("setting.unkown")}}</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="item" @click="toSetBank()">
          <div class="left">{{$t("setting.bind_bank_info")}}</div>
          <div class="right">
            <span class="desc">{{this.isBank ? this.$t("setting.bindinged") : this.$t("setting.no_setting")}}</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="item" @click="toBindUsdt()">
          <div class="left">USDT-TRC20</div>
          <div class="right">
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive:false,
      show:false,
      isBank:false,
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    toSetName(){
      this.$router.push({path:'/Setname'});
    },
    toSetBank(){
      this.$router.push({path:'/Setbank'});
    },
    toBindUsdt(){
      this.$router.push({path:'/BindUsdt'});
    },
    toSetSex(){
      this.$router.push({path:'/Setsex'});
    },
    openHerderImg(){
      this.show = true;
    },
    select_header_img(url){
        this.isActive = url;
    },
    check(){
      this.$http({
        method: 'post',
        data:{header_img:this.isActive},
        url: 'user_header_img'
      }).then(res=>{
        if(res.code === 200){
          this.getUserInfo();
          this.$toast(res.msg);
          this.show = false;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.isBank = true;
          }else {
            this.isBank = false;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container {
  min-height: 100%;
  background: #f5f5f5;
}

.page-body {
  padding: 10px 16px 0;
}

.items {
  background: #fff;
  font-size: 30px;
}

.item {
  padding: 30px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #000;
  border-bottom: 1px solid #ededed;
}

.item:last-child {
  border-bottom: none;
}

.left {
  color: #000;
}

.right {
  display: flex;
  align-items: center;
}

.avatar-preview {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  object-fit: cover;
  background: #fff;
}

.desc-cell-number,
.desc {
  font-size: 30px;
  font-weight: 700;
  color: #979799;
}

.desc {
  margin-right: 8px;
}

::v-deep .info-nav {
  background: #fff;
}

::v-deep .info-nav .van-nav-bar__title {
  color: #000;
}

::v-deep .info-nav::after {
  border-bottom: 1px solid #ededed;
}

.nav-back {
  color: #8795ad;
}

::v-deep .item .van-icon {
  color: #9d9d9d;
}

.avatarbox{
  padding: 15px;
  color: #000;
  height: 81%;
  background-color: #fff;
}
.avatarbox .title{
  padding: 8px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}

.avatarbox .content .van-image{
  width: 105px;
  height: 105px;
  margin: 2.5%;
  border-radius: 50%;
}
.avatarbox .content{
  padding-bottom: 10px;
  height: 100%;
  overflow-y: auto;
  padding-top: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.avatarbox .content .choose{
  width: 95px;
  height: 95px;
  border: 6px solid #e6c3a1;
}
</style>
